import React, { useState } from 'react';
import SupportModalContainer from '../SupportModal/SupportModalContainer';
import {
  DefaultAuthContainer,
  QrContainer,
  SupportContainer,
  SupportLink,
  QrText,
  WhatsappLink,
  QrCodeContainer,
} from './AuthComponents';
import QRCode from 'react-qr-code';

const MainAuthComponent = ({ children }) => {
  const [isOpenSupportModal, setIsOpenSupportModal] = useState(false);

  return (
    <DefaultAuthContainer>
      <div />
      <div>{children}</div>
      <SupportContainer>
        <QrContainer>
          <QrCodeContainer>
            <QRCode
              value={process.env.REACT_APP_MAX ?? ''}
              size={80}
              viewBox={`0 0 256 256`}
              style={{ height: '100%', width: '100%' }}
            />
          </QrCodeContainer>
          <QrText>
            <span>
              БЫСТРЫЙ ДОСТУП В ЧАТ
              <WhatsappLink href={process.env.REACT_APP_MAX ?? ''}>MAX</WhatsappLink>
            </span>
            <span>Наведите камеру телефона</span>
          </QrText>
        </QrContainer>
        Нужна помощь? Обратитесь в{' '}
        <SupportLink onClick={() => setIsOpenSupportModal(true)}>Техподдержку</SupportLink>
      </SupportContainer>
      <SupportModalContainer
        open={isOpenSupportModal}
        onClose={() => setIsOpenSupportModal(false)}
      />
    </DefaultAuthContainer>
  );
};

export default MainAuthComponent;
